<template>
    <b-form-checkbox
        :id="cb.name"
        v-model="cb.status"
        :name="cb.name"
        value="done"
        unchecked-value="todo"
        switch
        @change="toggle()"
    ></b-form-checkbox>
</template>

<script>
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'CheckDeadline',

    mixins: [DataUpdater],

    props: ['cb', 'type'],

    methods: {
        async toggle() {
            try {
                await axios.put(
                    `/clientDeadlines/${this.cb.deadline_id}/toggle`
                )
                await this.$store.dispatch('reportingVM/getCounter', 'all')
                await this.$store.dispatch('reportingVM/getCounter', this.type)
                this.updateData()
            } catch (error) {
                // handle error
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
